import React from 'react';
import { areProgramMetadataValid, formTimeString, getLiveDateStringFromPercentageWithinDVRWindow, getLiveDateStringFromPercentageWithinProgramWindow, getLiveProgressFromPercentageWithinDVRWindow, } from '@24i/player-utils';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { formatTime } from '@24i/nxg-core-utils';
import { ProgressTimeContainer } from '../../styled';
import { Time, Container } from './styled';
const PERCENT = 100;
const HOUR_MS = 60 * 60 * 1000;
export const ProgressTime = ({ progress = 0, duration, isVisible, className = '', playerInstance, programRange, showHours = true, styles = {
    container: null,
    backgroundContainer: null,
    time: null,
}, }) => {
    var _a, _b, _c;
    const timeFormat = (_a = useFeature('localization')) === null || _a === void 0 ? void 0 : _a.timeFormat;
    const numericPercentage = progress / PERCENT;
    const isLive = !!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.live);
    const { start, end } = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.timeshiftRange) || {
        start: 0,
        end: 0,
    };
    const { programStart, programEnd } = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.getMetadata()) || {
        programStart: 0,
        programEnd: 0,
    };
    const rangeStart = (_b = programRange === null || programRange === void 0 ? void 0 : programRange.start) !== null && _b !== void 0 ? _b : programStart;
    const rangeEnd = (_c = programRange === null || programRange === void 0 ? void 0 : programRange.end) !== null && _c !== void 0 ? _c : programEnd;
    let milliseconds;
    if (!isLive) {
        milliseconds = numericPercentage * duration;
    }
    else if (areProgramMetadataValid(rangeStart, rangeEnd)) {
        milliseconds = getLiveDateStringFromPercentageWithinProgramWindow(rangeStart, rangeEnd, numericPercentage);
    }
    else {
        const target = getLiveProgressFromPercentageWithinDVRWindow(start, end, numericPercentage);
        const timestamp = playerInstance.getUTCTimestamp(target);
        if (timestamp) {
            milliseconds = timestamp.getTime();
        }
        else {
            milliseconds = getLiveDateStringFromPercentageWithinDVRWindow(start, end, numericPercentage, Date.now());
        }
    }
    let timeString;
    if (isLive) {
        timeString = formatTime(milliseconds, timeFormat);
    }
    else {
        const finalShowHours = showHours === true || (showHours === 'auto' && (isLive || milliseconds > HOUR_MS));
        timeString = formTimeString(milliseconds, finalShowHours, false);
    }
    const { theme } = useTheme();
    if (!isVisible)
        return null;
    return (React.createElement(ProgressTimeContainer, { progress, className: `${className} ProgressTime`, style: styles.container },
        React.createElement(Container, { style: styles.backgroundContainer, "data-test": "ProgressTime-Container", className: "ProgressTime-Container" },
            React.createElement(Time, { style: Object.assign(Object.assign({}, getFont(theme, 'h5')), styles.time), "data-test": "ProgressTime-Time", className: "ProgressTime-Time", theme: theme }, timeString))));
};
//# sourceMappingURL=index.js.map